import { Component, Input } from '@angular/core';
import { Review } from '../../models/review.model';

@Component({
  selector: 'ess-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  standalone: false,
})
export class ReviewComponent {
  @Input() review: Review | undefined;
}
